import React from 'react';
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';

import IMAGES from 'shared/constants/images';
import generateID from 'shared/modules/common/utils/generate-id';

type Props = {
  onItemPress?: (index: number) => void;
  isShoppingEnabled?: boolean;
};

const HelpTiles = (props: Props) => {
  const TILES = [
    {
      image: IMAGES.helpTile1,
      label: '翌月あと払い',
    },
    {
      image: IMAGES.helpTile2,
      label: 'お支払い方法',
    },
    {
      image: IMAGES.helpTile3,
      label: '3・６・１２回あと払い',
    },
    {
      image: IMAGES.helpTile4,
      label: props.isShoppingEnabled ? 'お買い物' : '使えるお店',
    },
  ];

  return (
    <View style={style.root}>
      {TILES.map((_, index) => (
        <TouchableOpacity
          key={index}
          style={style.tile}
          onPress={() => props.onItemPress?.(index)}
          /** Generate HTML and Test IDs  */
          {...generateID(`help-tile-${index}`)}
          /** Platform-specific props */
          {...Platform.select({
            web: {
              accessibilityRole: 'button',
            },
          })}
        >
          <View style={style.imageWrapper}>
            <Image source={{ uri: TILES[index].image }} style={style.image} />
          </View>
          <Text style={style.tileText}>{TILES[index].label}</Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: -8,
  },
  tile: {
    padding: 8,
    width: '50%',
  },
  imageWrapper: {
    height: 156,
    marginBottom: 8,
  },
  image: {
    borderRadius: 16,
    width: '100%',
    height: '100%',
  },
  tileText: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default HelpTiles;
